import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { UserService } from 'lingo2-models';
import { OnUiButtonModule, OnUiCoverModule } from 'onclass-ui';

@Component({
  selector: 'app-library-course-mini',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, OnUiCoverModule, OnUiButtonModule],
  templateUrl: './library-course-mini.component.html',
  styleUrls: ['./library-course-mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibraryCourseMiniComponent {
  @Input() course: UserService;
  @Output() clicked = new EventEmitter<{ type: string; course: UserService }>();

  constructor() {}
}
